import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { UpgraderService } from '../upgrader.service';
import { CostComponent } from '../../../core/components/cost/cost.component';
import { SessionService } from '@core/services/session.service';

@Component({
  selector: 'app-upgrader-selected-skins',
  templateUrl: './upgrader-selected-skins.component.html',
  styleUrls: ['./upgrader-selected-skins.component.scss'],
  standalone: true,
  imports: [CostComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgraderSelectedSkinsComponent {
  public upgraderService = inject(UpgraderService);
  public sessionService = inject(SessionService);

  removeFirstItem() {
    if (this.upgraderService.isProcessing()) {
      return;
    }
    this.upgraderService.selectedSkinsS.update((prev) => {
      return prev.slice(1);
    });
  }
}
